import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "user-menu__group" }
const _hoisted_2 = {
  key: 0,
  class: "user-menu__welcome"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Hi ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" ! ")
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "user-menu__menu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_current_user = _resolveComponent("current-user")!
  const _component_base_menu_item = _resolveComponent("base-menu-item")!
  const _component_base_menu_list = _resolveComponent("base-menu-list")!
  const _component_base_dropdown = _resolveComponent("base-dropdown")!

  return (_openBlock(), _createBlock(_component_base_dropdown, {
    align: "right",
    class: _normalizeClass(["user-menu", { 'user-menu--with-username': _ctx.showUserName }]),
    onToggleMenu: _ctx.toggleMenu
  }, {
    default: _withCtx(({ toggleOpen }) => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.showUserName)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_current_user, {
                tag: "span",
                filter: _ctx.firstNameFilter
              }, null, 8, ["filter"]),
              _hoisted_4
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "user-menu__activator",
          onClick: toggleOpen
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["user-menu__icon", { 'user-menu__icon--close': _ctx.isOpen }])
          }, null, 2)
        ], 8, _hoisted_5)
      ])
    ]),
    dropdown: _withCtx(() => [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_base_menu_list, null, {
          default: _withCtx(() => [
            _createVNode(_component_base_menu_item, {
              to: { name: 'settings' },
              label: "User Settings"
            }),
            (_ctx.$can('access', 'ADMIN_PANEL'))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.isAdminSection)
                    ? (_openBlock(), _createBlock(_component_base_menu_item, {
                        key: 0,
                        to: { name: 'dashboard' },
                        label: "Dashboard"
                      }))
                    : _createCommentVNode("", true),
                  (!_ctx.isAdminSection)
                    ? (_openBlock(), _createBlock(_component_base_menu_item, {
                        key: 1,
                        to: { name: 'admin' },
                        label: "Administration"
                      }))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.$can('access', 'PRODUCTION_PANEL'))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.isProductionSection)
                    ? (_openBlock(), _createBlock(_component_base_menu_item, {
                        key: 0,
                        to: { name: 'dashboard' },
                        label: "Dashboard"
                      }))
                    : _createCommentVNode("", true),
                  (!_ctx.isProductionSection)
                    ? (_openBlock(), _createBlock(_component_base_menu_item, {
                        key: 1,
                        to: { name: 'Production' },
                        label: "Production"
                      }))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            _createVNode(_component_base_menu_item, {
              button: "",
              to: { name: 'terms-and-conditions' },
              label: "Terms and conditions"
            }),
            _createVNode(_component_base_menu_item, {
              button: "",
              class: "user-menu__logout",
              label: "Logout",
              onClick: _ctx.logout
            }, null, 8, ["onClick"])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["class", "onToggleMenu"]))
}